import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class TrainingPlanService {

  constructor(private http: HttpClient) { }

  addPlan(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "training-plan", data).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  getPlans(data, jobId): Observable<any> {
    // console.log("Adding clients", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "training-plan?learnerId=" + data + "&jobId=" + jobId).subscribe((res: any) => {

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  editPlan(data: any): Observable<any> {
    console.log("Edit Plan", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "training-plan", data).subscribe((res: any) => {
        console.log("Edited Plan : ", res);
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  deletePlan(eventId, learnerId) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "training-plan?eventId=" + eventId + '&learnerId=' + learnerId).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        });

    })
  }
}
